import { DItemConfiguracion, DItemRangoCasillas } from '@dian-cmp/formulario';
import { DInterfaceConfiguracionFormulario } from '@dian-cmp/formulario';
import { IDObserverTimerSession } from '@dian/core';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DContextoUsuarioServicio } from '@dian/api-identidad';

export class DObserverTimerSessionApp implements IDObserverTimerSession{
    
    constructor(
        private dNotificacionServicio: DNotificacionServicio,
        private dContextoUsuarioServicio: DContextoUsuarioServicio
    ) {}
    
    public cerrarSession(){
        let dialogo = this.dNotificacionServicio.mostrarDialogoInformacion('Su sesión ha expirado');
        dialogo.afterClosed().subscribe(result => {
            this.dContextoUsuarioServicio.logOut();
        });
    }
}

export class DFormularioConfiguracion implements DInterfaceConfiguracionFormulario {

	public USA_FORMULARIO_PAGO_NUEVO: boolean = true;
    public SOLO_USUARIO_INVITADO: boolean = false;
    public NUMERO_FORMULARIO = 300;//numero formulario ejemplo
    public VERSION_FORMATO = null;//numero de la version del formato
    public PUEDE_SUBIR_ARCHIVOS: boolean = false;
    public USA_CERTIFICADO_FIRMA_OBLIGATORIO = true;
    public CASILLA_NIT:string = null;
    public CASILLA_ES_CORRECCION:string = null;
    public CASILLA_SANCION:string = null
    public CASILLA_NUM_FORM_ANTERIOR:string = null
    public RANGO_CUERPO = new DItemRangoCasillas(0, 0);//rango ejemplo
    public REGLAS_FORMULARIO:Array<DItemConfiguracion> = new Array<DItemConfiguracion>();

}



// WEBPACK FOOTER //
// D:/arquitectura/workspace/Form300/Diligenciamiento_IngresoIva300_1.0.0/Diligenciamiento_IngresoIva300_1.0.0/Angular/Iva300Ingreso/src/app/configuracion/dformulario-configuracion.ts